module.exports = __webpack_public_path__ + "static/the-art-of-loving-e0ccc33e143b201ce4d1f429af176247.jpg";